module.exports = __webpack_public_path__ + "media/src/assets/Images/ArrowButtonLeft-8a9382b85a1925b91c2cda0059e019a9.svg";